export default __webpack_public_path__ + "static/media/nuScenes_logo_w.3f8282de.svg";